export default __webpack_public_path__ + "static/media/carousel2.89752152.png";